/**
 * App Store — Estado global de la aplicación.
 */

import { create } from 'zustand';

interface AppStore {
  sidebarOpen: boolean;
  currentPeriod: string;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setCurrentPeriod: (period: string) => void;
}

export const useAppStore = create<AppStore>((set) => ({
  sidebarOpen: true,
  currentPeriod: new Date().toISOString().slice(0, 7),

  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setCurrentPeriod: (period) => set({ currentPeriod: period }),
}));
